module.exports = __webpack_public_path__ + "static/img/p-11.919fe24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-11.png
// module id = j4Uy
// module chunks = 0